import { type IntlShape } from 'react-intl-next';
import messages from './messages';

export const getTutorialContent = (
	intl: IntlShape,
	isProjectPagesSporkRebrandingEnabled: boolean = false,
) => {
	const tutorialContentShippingSpeedStatistic = intl.formatMessage(
		messages.tutorialContentShippingSpeedStatistic,
	);
	const tutorialContentShippingSpeedStatisticSporkRebranding = intl.formatMessage(
		messages.tutorialContentShippingSpeedStatisticSporkRebranding,
	);
	const tutorialContentGettingStatedTips = intl.formatMessage(
		messages.tutorialContentGettingStatedTips,
	);
	const tutorialContentConfluenceTemplates = intl.formatMessage(
		messages.tutorialContentConfluenceTemplates,
		{
			a: (...chunks) =>
				`<a href="https://www.atlassian.com/software/confluence/templates">${chunks}</a>`,
			b: (...chunks) => `<strong>${chunks}</strong>`,
		},
	);
	const tutorialContentEditAndFormat = intl.formatMessage(messages.tutorialContentEditAndFormat, {
		b: (...chunks) => `<strong>${chunks}</strong>`,
		c: (...chunks) => `<code>${chunks}</code>`,
	});

	const tutorialContentSpacesAndPages = intl.formatMessage(messages.tutorialContentSpacesAndPages, {
		a: (...chunks) =>
			`<a href="https://www.atlassian.com/software/confluence/guides/get-started/set-up">${chunks}</a>`,
		b: (...chunks) => `<strong>${chunks}</strong>`,
	});
	const tutorialContentJiraAndConfluence = intl.formatMessage(
		messages.tutorialContentJiraAndConfluence,
	);
	const tutorialContentJiraLinks = intl.formatMessage(messages.tutorialContentJiraLinks, {
		c: (...chunks) => `<code>${chunks}</code>`,
	});

	const tutorialContentJiraTimeline = intl.formatMessage(messages.tutorialContentJiraTimeline, {
		c: (...chunks) => `<code>${chunks}</code>`,
	});

	const tutorialContentJiraCharts = intl.formatMessage(messages.tutorialContentJiraCharts, {
		c: (...chunks) => `<code>${chunks}</code>`,
	});
	const tutorialContentTryItNow = intl.formatMessage(messages.tutorialContentTryItNow);

	const tutorialContentForwardSlashPrompt = intl.formatMessage(
		messages.tutorialContentForwardSlashPrompt,
	);
	const tutorialContentHandyLinks = intl.formatMessage(messages.tutorialContentHandyLinks);

	const content = `<h4><ac:emoticon ac:name="blue-star" ac:emoji-shortname=":rocket:" ac:emoji-id="1f680" ac:emoji-fallback="🚀" /><strong>${
		isProjectPagesSporkRebrandingEnabled
			? tutorialContentShippingSpeedStatisticSporkRebranding
			: tutorialContentShippingSpeedStatistic
	}</strong></h4><p>${tutorialContentGettingStatedTips}</p><ul><li><p>${tutorialContentConfluenceTemplates}</p></li><li><p>${tutorialContentEditAndFormat}</p></li><li><p>${tutorialContentSpacesAndPages}</p></li></ul><h3><ac:emoticon ac:name="blue-star" ac:emoji-shortname=":palms_up_together:" ac:emoji-id="1f932" ac:emoji-fallback="🤲" />${tutorialContentJiraAndConfluence}</h3><ul><li><p>${tutorialContentJiraLinks}</p></li><li><p>${tutorialContentJiraTimeline}</p></li><li><p>${tutorialContentJiraCharts}</p></li></ul>${
		isProjectPagesSporkRebrandingEnabled
			? ''
			: '<a href="https://www.youtube.com/watch?v=ohtDFXNAUns&amp;t=1s" data-layout="center" data-original-height="480.00" data-width="66.67" data-original-width="853.34" data-card-appearance="embed">https://www.youtube.com/watch?v=ohtDFXNAUns&amp;t=1s</a>'
	}<ac:structured-macro ac:name="tip" ac:schema-version="1" ac:macro-id="45fcf348-9a07-42f8-b131-b48f9b1e50b3"><ac:rich-text-body><h3><strong><span style="color: rgb(54,179,126);">${tutorialContentTryItNow}</span></strong><ac:emoticon ac:name="blue-star" ac:emoji-shortname=":point_down:" ac:emoji-id="1f447" ac:emoji-fallback="👇" /></h3></ac:rich-text-body></ac:structured-macro><table data-layout="default" ac:local-id="3b898e26-4024-4420-9593-3646c925e48b"><colgroup><col style="width: 680.0px;" /></colgroup><tbody><tr><th data-highlight-colour="#ffffff"><p><span style="color: rgb(151,160,175);">${tutorialContentForwardSlashPrompt}</span></p><p> </p></th></tr></tbody></table><p /><p> <ac:emoticon ac:name="blue-star" ac:emoji-shortname=":ok_hand:" ac:emoji-id="1f44c" ac:emoji-fallback="👌" />${tutorialContentHandyLinks}</p><p><a href="https://www.atlassian.com/software/confluence/jira-integration" data-card-appearance="inline">https://www.atlassian.com/software/confluence/jira-integration</a> </p><p><a href="https://www.youtube.com/watch?v=ybQIV15BO44" data-card-appearance="inline">https://www.youtube.com/watch?v=ybQIV15BO44</a> </p><p><a href="https://www.atlassian.com/software/confluence/guides" data-card-appearance="inline">https://www.atlassian.com/software/confluence/guides</a> </p><hr /><p />`;

	return content;
};
